/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Trace_Weighing_QuantityInputs */

const vi_trace_weighing_quantity = /** @type {(inputs: Trace_Weighing_QuantityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khối lượng`)
};

/**

* @param {Trace_Weighing_QuantityInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const trace_weighing_quantity = /** @type {((inputs?: Trace_Weighing_QuantityInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trace_Weighing_QuantityInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_trace_weighing_quantity(inputs)
});